import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, EventEmitter, OnInit, Inject, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NdmsSafeSubscriber } from 'projects/shared/core/interfaces/ndms-safe-subscriber';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { confirmPasswordValidator } from 'projects/shared/core/validators/confirm-password-validator.directive';
import { IdentityAccountsService } from 'ndms/app/shared/core-ndms/services/identity-accounts.service';
import { IdentityAccountModel } from 'ndms/app/shared/core-ndms/models/identity-account.model';
import { NdmsUsersService } from 'ndms/app/shared/core-ndms/services/ndms-users.service';

@Component({
  selector: 'profile-edit',
  templateUrl: './profile-edit.component.html',
  styleUrls: ['./profile-edit.component.scss']
})
export class ProfileEditComponent extends NdmsSafeSubscriber implements OnInit {
  @Output('onComplete') complete = new EventEmitter();

  public ndmsUser: any;

  private _identityAccount: IdentityAccountModel;
  public get identityAccount() {
    return this._identityAccount;
  }
  public set identityAccount(value) {
    this._identityAccount = value;
    this._identityAccount$.next(value);
  }

  private _identityAccount$ = new BehaviorSubject(this.identityAccount);
  public get identityAccount$(): Observable<IdentityAccountModel> {
    return this._identityAccount$.asObservable();
  }

  public form: FormGroup;
  public responseMessages: any[] = [];
  public passwordDoesNotMatch: boolean = false;
  public manualPasswordReset = false;
  public passwordResetComplete = false;
  public applications: any = [];
  public isLoadingIdentityAccount: boolean = false;
  public isSendInvitationDisabled = false;
  public reset2FAComplete: boolean = false;
  constructor(
    @Inject('HELP_ISSUE') public helpIssue: string,
    @Inject('HELP_LINK') public helpLink: string,
    @Inject('HELP_EMAIL') public helpEmail: string,
    @Inject('HELP_NUMBER') public helpNumber: string,
    private _formBuilder: FormBuilder,
    private _lookupService: LookupService,
    private _ndmsUsersService: NdmsUsersService,
    private _identityAccountsService: IdentityAccountsService) {
    super();
    this.applications = this._lookupService.get('applications');
  }

  ngOnInit() {
    this.ndmsUser = {
      key: '',
      userName: '',
      firstName: '',
      lastName: '',
      phoneMobile: ''
    }
    this.form = this._formBuilder.group({
      password: [''],
      passwordConfirm: ['']
    }, {
      validators: confirmPasswordValidator
    });
  }

  patchFormValues() {
    if (this.ndmsUser && Object.keys(this.ndmsUser).length > 0) {
      //this.form.get('twoFactorEnabled').setValue(this.identityAccount.twoFactorEnabled);

      // this.addApplicationCheckboxes(this.ndmsUser);

      this.form.markAsTouched();

      if (!this.identityAccount && this.ndmsUser && this.ndmsUser.userName && !this.isLoadingIdentityAccount) {
        this.queryForIdentityAccount();
      }
    }
  }

  queryForIdentityAccount() {
    if (!this.isLoadingIdentityAccount) {
      this.isLoadingIdentityAccount = true;

      var userName = this.ndmsUser.userName;
      this.safeSubscribe(this._identityAccountsService.Query({ email: userName }), result => {
        if (result && result.model && result.model.length > 0) {
          this.identityAccount = result.model[0];

          this.ndmsUser.phoneMobile = this.identityAccount.phoneMobile;
        } else {
          this.identityAccount = undefined;
        }

        this.isLoadingIdentityAccount = false;
      });
    }
  }

  controlIsInvalid(control: string) {
    return ((this.form.get(control).touched || this.form.get(control).dirty) && this.form.get(control).invalid);
  }

  controlHasError(control: string, condition: string) {
    return this.form.get(control).errors && this.form.get(control).errors[condition];
  }

  passwordDoesNotConfirm() {
    return this.form.errors && this.form.errors.doesNotMatch;
  }

  onCompleteClick() {
    this.form.get('password').setErrors(null);
    this.form.get('passwordConfirm').setErrors(null);

    if (this.form.valid) {
      var ndmsUser = Object.assign({}, this.ndmsUser);

      this._ndmsUsersService.saveUser(ndmsUser).then((res) => {
        if (res.responseMessages.length > 0) {
          this.responseMessages = res.responseMessages;
        } else {
          this.responseMessages = [];

          if (this.identityAccount) {
            var identityAccount: IdentityAccountModel = Object.assign({}, this.identityAccount);
            identityAccount.password = this.form.get('password').value;
            identityAccount.confirmPassword = this.form.get('passwordConfirm').value;
            identityAccount.assignedApps = [];
            identityAccount.resetPasswordOnLogin = false;

            this._identityAccountsService.Save(identityAccount, identityAccount.id).subscribe((res) => {
              if (res.responseMessages.length > 0) {
                this.responseMessages = res.responseMessages;
              } else {
                this.responseMessages = [];

                this.complete.emit(ndmsUser);
              }
            });
          } else {
            if (!this.isLoadingIdentityAccount) {
              this.isLoadingIdentityAccount = true;


              this._identityAccountsService.Query({ email: this.ndmsUser.userName }).subscribe(result => {
                if (result && result.model && result.model.length > 0) {
                  var identityAccount = result.model[0];

                  identityAccount.password = this.form.get('password').value;
                  identityAccount.confirmPassword = this.form.get('passwordConfirm').value;
                  identityAccount.assignedApps = [];
                  identityAccount.resetPasswordOnLogin = false;

                  this._identityAccountsService.Save(identityAccount, identityAccount.id).subscribe((res) => {
                    if (res.responseMessages.length > 0) {
                      this.responseMessages = res.responseMessages;
                    } else {
                      this.responseMessages = [];

                      this.complete.emit(ndmsUser);
                    }
                  });
                } else {
                  this.complete.emit(ndmsUser);
                }

                this.isLoadingIdentityAccount = false;
              });
            } else {
              this.complete.emit(ndmsUser);
            }
          }
        }
      });
    }
  }

  onCloseClick() {
    this.complete.emit(this.ndmsUser);
  }

  onManualPasswordResetClick() {
    this.form.get('password').setValidators([Validators.required, Validators.pattern(/^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])).{14,}$/)]);
    this.form.get('passwordConfirm').setValidators([Validators.required]);

    this.manualPasswordReset = !this.manualPasswordReset;
  }

  onReset2FAClick() {
    if (confirm("Are you sure you want to reset Two-Factor Authentication?") && this.identityAccount) {
      this._identityAccountsService.Reset2FA(this.identityAccount.id).subscribe((res) => {
        if (res) {
          this.reset2FAComplete = true;

        }
      });
    }
  }

  getMask() {
    return { mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] };
  }
}
